import { Component, Input } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { VideoService } from 'rev-shared/media/Video.Service';

import styles from './approval-dialog.module.less';

@Component({
	selector: 'approval-dialog',
	templateUrl: './ApprovalDialog.Component.html'
})

export class ApprovalDialogComponent {

	@Input() public isApproved: boolean;
	@Input() public video: any;

	public readonly styles = styles;

	public isProcessing: boolean;
	public reason: string;

	constructor(
		private VideoService: VideoService,
		private modalInstance: BsModalRef
	) { }

	private approveVideo(): void {
		this.VideoService
			.approveVideo(this.video, this.reason)
			.then(() => this.closePopup());
	}

	private rejectVideo(): void {
		this.VideoService
			.rejectVideo(this.video, this.reason)
			.then(() => this.closePopup());
	}

	private closePopup(): void {
		this.isProcessing = false;
		this.modalInstance.hide();
	}

	public cancel(): void {
		this.modalInstance.hide();
	}

	public submit(): void {
		this.isProcessing = true;
		this.isApproved ? this.approveVideo() : this.rejectVideo();
	}

}
